// extracted by mini-css-extract-plugin
export default {"mapWrapper":"ThumbMap_mapWrapper__2uN0h","disable":"ThumbMap_disable__998wS"};